import script from "./InputFile.vue?vue&type=script&setup=true&lang=js"
export * from "./InputFile.vue?vue&type=script&setup=true&lang=js"

import "./InputFile.vue?vue&type=style&index=0&id=5376afe8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5376afe8"]])

export default __exports__